var _rect, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBookmarkDefault(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 4,
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "-25 -15 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.242188 43.9797V9.97974H14.2422V29.785L0.242188 43.9797Z",
    fill: "#6166F1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2422 48.9797V9.97974H15.2422V29.7167L29.2422 48.9797Z",
    fill: "#6166F1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.534 0.979736H3.94017C1.89143 0.979736 0.242188 2.63491 0.242188 4.66812V8.97974H29.2422V4.66812C29.2422 2.63491 27.5827 0.979736 25.534 0.979736ZM4.93382 6.64002C4.18602 6.64002 3.58164 6.03721 3.58164 5.29136C3.58164 4.54551 4.18602 3.9427 4.93382 3.9427C5.68161 3.9427 6.28599 4.54551 6.28599 5.29136C6.28599 6.03721 5.68161 6.64002 4.93382 6.64002ZM10.2401 6.64002C9.49227 6.64002 8.8879 6.03721 8.8879 5.29136C8.8879 4.54551 9.49227 3.9427 10.2401 3.9427C10.9879 3.9427 11.5922 4.54551 11.5922 5.29136C11.5922 6.03721 10.9879 6.64002 10.2401 6.64002ZM15.5463 6.64002C14.7985 6.64002 14.1941 6.03721 14.1941 5.29136C14.1941 4.54551 14.7985 3.9427 15.5463 3.9427C16.2941 3.9427 16.8985 4.54551 16.8985 5.29136C16.8985 6.03721 16.2941 6.64002 15.5463 6.64002Z",
    fill: "#6166F1"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkDefault);
export default __webpack_public_path__ + "static/media/bookmarkDefault.dbb5458e3b5983c4cb2b8d853c68bb49.svg";
export { ForwardRef as ReactComponent };